import { EditorState } from 'draft-js'

export const initState = {
  global: {
    alert: {
      open: false,
      message: "",
      severity: undefined
    }
  },
  deal: {
    name: '',
    desc: EditorState.createEmpty() ,
    websiteUrl: '',
    leadInvestor: '',
    crypto: '',
    presailAmount: 0,
    minsaleAmount: 0,
    maxsaleAmount: 0,
    minStakeAmount: 0,
    maxStakeAmount: 0,
    startBonus: 0,
    endBonus: 0,
    price: 0,
    logo: '',
    offerPeriod: 0,
    offerTerms: EditorState.createEmpty() 
  },
  stake: {
    amount: 0
  }
}